import React, { useState } from "react";
import { Link } from "react-router-dom";

const glossary = [
  {
    category: "Базовые термины",
    term: "опцион (option)",
    transliteration: "option",
    definition: "Договор, дающий право, но не обязанность, купить или продать актив в будущем по заранее установленной цене.",
    example: "Инвестор покупает опцион, чтобы зафиксировать цену на акции."
  },
  {
    category: "Базовые термины",
    term: "колл-опцион (call option)",
    transliteration: "call option",
    definition: "Опцион, дающий покупателю право купить актив по заранее определённой цене.",
    example: "Трейдер покупает колл-опцион, ожидая рост акций."
  },
  {
    category: "Базовые термины",
    term: "пут-опцион (put option)",
    transliteration: "put option",
    definition: "Опцион, дающий покупателю право продать актив по заранее определённой цене.",
    example: "Инвестор хеджирует риски, покупая пут-опцион."
  },
  {
    category: "Базовые термины",
    term: "страйк-цена (strike price)",
    transliteration: "strike price",
    definition: "Цена, по которой держатель опциона может купить или продать актив.",
    example: "Колл-опцион имеет страйк-цену 150₽."
  },
  {
    category: "Базовые термины",
    term: "премия (premium)",
    transliteration: "premium",
    definition: "Цена, уплаченная за покупку опциона.",
    example: "Опцион куплен за премию в 5₽."
  },
  {
    category: "Показатели риска (Греки)",
    term: "дельта (delta)",
    transliteration: "delta",
    definition: "Показатель, отражающий изменение цены опциона при изменении цены базового актива на 1 единицу.",
    example: "Дельта равна 0.5 — значит, опцион растёт на 0.5₽ при росте актива на 1₽."
  },
  {
    category: "Показатели риска (Греки)",
    term: "гамма (gamma)",
    transliteration: "gamma",
    definition: "Показывает скорость изменения дельты при изменении цены базового актива.",
    example: "Высокая гамма указывает на чувствительность дельты."
  },
  {
    category: "Показатели риска (Греки)",
    term: "тета (theta)",
    transliteration: "theta",
    definition: "Отражает изменение стоимости опциона при приближении к дате экспирации.",
    example: "Отрицательная тета указывает на потерю стоимости во времени."
  },
  {
    category: "Показатели риска (Греки)",
    term: "вега (vega)",
    transliteration: "vega",
    definition: "Изменение стоимости опциона при изменении подразумеваемой волатильности.",
    example: "Повышение волатильности увеличивает стоимость опциона с положительной вегой."
  },
  {
    category: "Показатели риска (Греки)",
    term: "ро (rho)",
    transliteration: "rho",
    definition: "Показывает изменение стоимости опциона при изменении процентной ставки.",
    example: "Рост ставок увеличивает стоимость колл-опционов."
  }
];

export default function GlossaryPage() {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("Все");

  const categories = ["Все", ...Array.from(new Set(glossary.map((t) => t.category)))];

  const filtered = glossary
    .filter(
      (item) =>
        (category === "Все" || item.category === category) &&
        (item.term.toLowerCase().includes(search.toLowerCase()) ||
          item.definition.toLowerCase().includes(search.toLowerCase()) ||
          item.transliteration.toLowerCase().includes(search.toLowerCase()))
    );

  return (
    <div style={{ fontFamily: "sans-serif", padding: "2rem" }}>
      <Link to="/" style={{ display: "inline-block", marginBottom: "1rem", color: "#0070f3" }}>
        ← Вернуться на главную
      </Link>
      <h1 style={{ textAlign: "center", fontSize: "2rem", marginBottom: "1rem" }}>Глоссарий</h1>
      <div style={{ textAlign: "center", marginBottom: "1rem" }}>
        <input
          type="text"
          placeholder="Поиск..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            padding: "0.75rem",
            width: "100%",
            maxWidth: "400px",
            fontSize: "1rem",
            border: "1px solid #ccc",
            marginLeft: "1rem",
            borderRadius: "6px",
            marginBottom: "1rem"
          }}
        />
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{
            padding: "0.5rem",
            fontSize: "1rem",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginLeft: "1rem",
            maxWidth: "300px",
            width: "100%"
          }}
        >
          {categories.map((c, i) => (
            <option key={i} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
      <div
        style={{
          display: "grid",
          gap: "1rem",
          maxWidth: "700px",
          margin: "0 auto"
        }}
      >
        {filtered.length > 0 ? (
          filtered.map((item, i) => (
            <div
              key={i}
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "1rem",
                backgroundColor: "#f9f9f9"
              }}
            >
              <h3 style={{ marginBottom: "0.25rem" }}>{item.term}</h3>
              <p style={{ fontStyle: "italic", color: "#666" }}>{item.transliteration}</p>
              <p style={{ marginBottom: "0.5rem" }}>{item.definition}</p>
              <small style={{ color: "#555" }}>{item.example}</small>
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", color: "#999" }}>Ничего не найдено.</p>
        )}
      </div>
    </div>
  );
}